if (!customElements.get('store-list-popup-opener')) {
    class StoreListPopupOpener extends HTMLElement {
        constructor() {
            super();
            this.addEventListener('click', this.openPopup);
        }

        openPopup() {
            this.modal = document.getElementById('PopupModal-store-list');
            this.storeList = [];
            this.currentStoreCode = getCookie('mor_store_code');

            if (this.modal) {
                this.modal.show();
                const storeListString = document.querySelector('#store-metafields');
                try {
                    if (storeListString) {
                        this.storeList = JSON.parse(storeListString.textContent);
                        this.displayData = JSON.parse(storeListString.textContent)
                    }
                } catch (error) {
                    console.error('Error parsing store list JSON:', error);
                }
                this.renderDisplayedStoreList();
            }
        }


        renderDisplayedStoreList() {
            this.loading(true);
            console.log('1. Start to render displayed store list');
            this.currentZipcode = getCookie('mor_zipcode')

            if (this.currentZipcode && this.modal.querySelector('[data-zipcode]')) {
                this.modal.querySelector('[data-zipcode]').textContent = this.currentZipcode;
            }
            this._renderStoreItem()
        }
        
        _renderStoreItem() {
            const storeTemplate = this.modal.querySelector('[data-store-list-item-template]');
            const storeListContainer = this.modal.querySelector('[data-store-list-container]');
            // Remove warehouse
            const displayedStore = this.storeList.filter(store => {
                return !store['store-cd'].startsWith('W') && store['store-cd'] !== 'XX' && store['store-cd'] !== '00';
            });

            this.getCurrentPosition(displayedStore, () => {
                console.log('3. render store', displayedStore)

                displayedStore.sort((a, b) => {
                    if (!a.distance) return 1;
                    if (!b.distance) return -1;
                    return a.distance - b.distance;
                });
                // Clear the existing store list
                storeListContainer.innerHTML = '';
                // Render the displayed stores
                displayedStore.forEach(store => {
                    const storeItem = storeTemplate.content.cloneNode(true);
                    if (store['store-cd'] === this.currentStoreCode) {
                        storeItem.firstElementChild.classList.add('current-store');
                    }
                    storeItem.querySelector('[data-address]').textContent = store['city'] + ', ' + store['st'];
                    store['distance'] 
                        ? storeItem.querySelector('[data-distance]').textContent = store['distance'] 
                        : storeItem.querySelector('.store-distance').classList.add('hidden');
                    storeItem.querySelector('[data-zipcode]').setAttribute('data-zipcode', store['zip-cd']);
                    storeItem.querySelector('[data-store-code]').setAttribute('data-store-code', store['store-cd']);
                    if (store['store-cd']) {
                        const firstLetterOfStoreCode = store['store-cd'].charAt(0).toUpperCase();
                        storeItem.querySelector('[data-warehouse-code]').setAttribute('data-warehouse-code', 'W' + firstLetterOfStoreCode);
                    }
                    storeItem.querySelector('[data-store-name]').setAttribute('data-store-name', store['store-name']);
                    storeListContainer.appendChild(storeItem);
                });
                console.log('4. render end')
                this.loading(false);
            });
        }

        async getCurrentPosition(storeList, callback) {
            this.loading(true)
            console.log('2. get current position');
            try {
                // Use Google Maps Geocoding API to get the latitude and longitude of the zipcode
                const apiKey = 'AIzaSyB_h9bBOlHQR88ImOmzdZJk3DuD94ngFZY';
                const zipCode = this.currentZipcode || getCookie('mor_zipcode');
                const response = await fetch(`https://maps.googleapis.com/maps/api/geocode/json?address=${zipCode}&key=${apiKey}`);
                if (response.ok) {
                    const data = await response.json();
                    if (data.status === 'OK' && data.results.length > 0) {
                        const location = data.results[0].geometry.location;
                        const userLat = location.lat;
                        const userLng = location.lng;

                        storeList.forEach(store => {
                            if (store.latitude && store.longitude) {
                                store.distance = calcGeoDistance(userLat, userLng, store.latitude, store.longitude);
                            } else {
                                store.distance = null;
                            }
                        });

                        storeList.sort((a, b) => {
                            if (a.distance === null) return 1;
                            if (b.distance === null) return -1;
                            return a.distance - b.distance;
                        });
                    }
                } else {
                    console.warn('Google Maps API request failed:', response.status);
                }
            } catch (error) {
                console.error('Failed to get zipcode geolocation:', error);
            } finally {
                if (callback && typeof callback === 'function') {
                    callback(storeList)
                }
            }
        }

        loading(isLoading) {
            const addLoadingWrapper = this.modal.querySelector('.display-store-list');

            if (isLoading) {
                addLoadingWrapper.querySelector('.loading__spinner').classList.remove('hidden');
            } else {
                addLoadingWrapper.querySelector('.loading__spinner').classList.add('hidden');
            }
        }
    }

    customElements.define('store-list-popup-opener', StoreListPopupOpener);
}